<app-dialog-layout>
  <ng-container content>
    <cpb-form-renderer [showHeader]="false" [formKey]="formKey" [context]="context"> </cpb-form-renderer>
  </ng-container>

  <ng-container buttons>
    <cap-button
      icon="fal fa-times"
      styleClass="secondary"
      [label]="'button.cancel' | translate"
      (onClick)="dialogRef.close()">
    </cap-button>

    <cap-button
      styleClass="primary"
      icon="fas fa-floppy-disk"
      [label]="'market_discovery.button.save' | translate"
      (onClick)="handleSave()">
    </cap-button>
  </ng-container>
</app-dialog-layout>
